<mat-label>
  <span [innerHTML]="componentDisplayAttributes.formControlAttributes.label"></span>
    <span
      [style.color]="
        radioFormControls[componentDisplayAttributes.formControlAttributes.formControlName]
          .errors
          ? '#a71919'
          : '#00304D'">*</span>
</mat-label>
@if (componentDisplayAttributes.custom?.tooltip) {
  <div class="premium-tooltipF" matTooltip="{{ componentDisplayAttributes.custom.tooltip }}">
    <span class="material-symbols-outlined">info</span>
  </div>
}
@if (componentDisplayAttributes.custom?.subLabel) {
  <div [innerHTML]="componentDisplayAttributes.custom?.subLabel"></div>
}
<mat-radio-group
  [formControlName]="componentDisplayAttributes.formControlAttributes.formControlName"
  [attr.aria-label]="componentDisplayAttributes.radioGroupAttributes?.label"
  [ngClass]="{ 'change-direction': componentDisplayAttributes?.custom?.order === 'column' }"
  (change)="inputChanged('change', $event)"
>
  @for (buttonConfig of componentDisplayAttributes.radioGroupAttributes.optionAttributes; track buttonConfig; let j = $index) {
    <mat-radio-button [value]="buttonConfig.value">
      {{ buttonConfig.label }}
    </mat-radio-button>
  }
</mat-radio-group>
@if (radioFormControls[componentDisplayAttributes.formControlAttributes.formControlName].errors && (radioForm.touched || radioForm.dirty)) {
  <mat-error class="cross-validation-error-message alert">
    @if (radioFormControls[componentDisplayAttributes.formControlAttributes.formControlName].errors.required) {
      <span>Required</span>
    }
  </mat-error>
}

